import React, { useState } from 'react';
import Logo from '../../logo.png';
import { Link } from 'react-router-dom';
import InfoblokkSmall from '../../infoblokk-small.webp'

const Navbar = () => {
  const [isActive, setIsActive] = useState(false);

  const theme = {
    darkSlate: '#1e293b',
    constructionOrange: '#f97316',
    lightGrey: '#f1f5f9',
    white: '#ffffff',
  };

  const toggleMenu = () => {
    setIsActive(!isActive);
  };

  const closeMenu = () => {
    setIsActive(false);
  };

  return (
    <nav
      className="navbar is-fixed-top"
      style={{ backgroundColor: theme.lightGrey, borderBottom: `3px solid ${theme.constructionOrange}` }}
      role="navigation"
      aria-label="main navigation"
    >
      <div className="container">
        <div className="navbar-brand">
          <a className="navbar-item" href="/" onClick={closeMenu}>

            <img
              src={Logo}
              alt="Sz. és Sz. Center Bt. Logo"
              style={{ marginRight: '12px', maxHeight: '4rem' }}
            />
          </a>

          {/* Megnövelt méretű Hamburger ikon */}
          <a
            role="button"
            className={`navbar-burger ${isActive ? 'is-active' : ''}`}
            aria-label="menu"
            aria-expanded="false"
            onClick={toggleMenu}
            style={{
              color: theme.darkSlate,
              transform: 'scale(1.3)',      /* 30%-kal felnagyítja az ikont */
              transformOrigin: 'center',    /* Középpontból nagyít */
              marginLeft: 'auto',           /* Jobbra igazítja */
              marginRight: '15px',          /* Eltartja a képernyő jobb szélétől */
              height: 'auto'                /* Alkalmazkodik az új navbar magassághoz */
            }}
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>

        <div
          className={`navbar-menu ${isActive ? 'is-active' : ''}`}
          style={{ backgroundColor: isActive ? theme.lightGrey : 'transparent' }}
        >
          <div className="navbar-end">

            <a className="navbar-item" href="/szechenyi-terv-plusz" onClick={closeMenu}>

              <img
                src={InfoblokkSmall}
                alt="Pályázat"
                style={{ marginRight: '12px', maxHeight: '4rem' }}
              />
            </a>
            <a
              className="navbar-item has-text-weight-semibold"
              href="/szechenyi-terv-plusz"
              onClick={closeMenu}
              style={{ color: theme.darkSlate }}
            >
              Pályázat
            </a>
                        <a
              className="navbar-item has-text-weight-semibold"
              href="/#bemutatkozas"
              onClick={closeMenu}
              style={{ color: theme.darkSlate }}
            >
              Rólunk
            </a>
            <a
              className="navbar-item has-text-weight-semibold"
              href="/#kapcsolat"
              onClick={closeMenu}
              style={{ color: theme.darkSlate }}
            >
              Kapcsolat
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;